/*@ngInject*/
const FunctionButtonController = function ($scope, $controller, $window, xmlUtil, formComponentUtil, formMediator,
                                           remoteFunction, remoteFunctionRepository,
                                           localization, $uibModal, loadingBarHandler,
                                           functionActionUtil, coreMediator, coreConstant) {

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}));

    this.execute = function () {
        let formId = this.fieldStructure.parentForm.id,
            fieldId = this.fieldStructure.fieldModel ? this.fieldStructure.fieldModel.id : null,
            fieldName = this.fieldStructure.indexedName,
            rowId = this.fieldStructure.rowInstanceId,
            rowIndex = this.fieldStructure.rowNumber,
            submissionId = this.fieldStructure.parentForm.submissionId,
            fieldStructure = this.fieldStructure,
            xmlOptions = xmlUtil.parseString(this.fieldStructure.uiField.options);

        localization.getTranslationByKey('formsViewer.controls.functionButton').then(function (translation) {

            let customOptions = {
                'confirmationMessage': xmlOptions.confirmationMessage,
                'confirmationTitle': (xmlOptions.confirmationTitle) ? xmlOptions.confirmationTitle : translation.title,
                'yesButtonLabel': (xmlOptions.yesButtonLabel) ? xmlOptions.yesButtonLabel : translation.yesButton,
                'noButtonLabel': (xmlOptions.noButtonLabel) ? xmlOptions.noButtonLabel : translation.noButton,
                'processingIndicatorText': (xmlOptions.processingIndicatorText) ? xmlOptions.processingIndicatorText : null,
                'functionClass': xmlOptions.functionClass,
                'parameters': xmlOptions.parameters
            };

            if (customOptions.functionClass === 'com.firstbest.components.formcomponent.functions.RemoteFunctionWrapper') {

                function handleLoadingBar(submissionId, formId, fieldId, rowIndex, customOptions, fieldStructure) {
                    if (customOptions.processingIndicatorText) {
                        loadingBarHandler.showLoadingBar(customOptions.processingIndicatorText);
                    }
                    executeContinue(submissionId, formId, fieldId, rowIndex, customOptions, fieldStructure);
                }

                if (customOptions.confirmationMessage !== '') {
                    showGenericConfirm(formId, fieldId, customOptions).then(function () {
                        handleLoadingBar(submissionId, formId, fieldId, rowIndex, customOptions, fieldStructure);
                    });

                } else {
                    handleLoadingBar(submissionId, formId, fieldId, rowIndex, customOptions, fieldStructure);
                }
            } else if (customOptions.functionClass === 'submissionAgencyChange') {
                showChangeAgencyModal(customOptions);
            } else {
                $scope.$emit(coreConstant.event.functionExecute, customOptions,
                        {submissionId:submissionId, formId:formId, fieldId:fieldId, fieldName:fieldName, rowId:rowId, rowIndex:rowIndex});
            }

        });
    };

    function executeContinue(submissionId, formId, fieldId, rowIndex, customOptions, fieldStructure) {
        let parameters = functionActionUtil.getParameterAsObject(customOptions.parameters),
            form = fieldStructure.parentForm,
            fieldInstance = fieldStructure.fieldModel,
            fieldTemplate = fieldStructure.uiField.fieldTemplate;

        fieldStructure.dynamicProperties.disabled = true;

        remoteFunction.executeFunction(formId, fieldId, rowIndex, parameters, submissionId).then(function (executorResult) {
            if (executorResult.url) {
                parameters.url = executorResult.url;
            }

            if (parameters.url) {
                coreMediator.loadUserProfile().then(function (userProfile) {
                    functionActionUtil.constructUrl(parameters, submissionId, userProfile).then((url) => {
                        $window.open(url);
                    });
                });
            }

            loadingBarHandler.hideLoadingBar();
        }).finally(function() {
            fieldStructure.dynamicProperties.disabled =
                formComponentUtil.isFieldDisabled(form, fieldInstance, fieldTemplate, form.hasWriteAccess);
        });
    };

    this.getButtonWidth = function() {
        const inputContainerWidth = 160;
        let isRowRepeater = this.fieldStructure.isRowRepeaterField;
        if(isRowRepeater && this.fieldStructure.layout.labelWidth === 0) {
            return inputContainerWidth;
        } else {
            return this.fieldStructure.layout.labelWidth;
    }
    };

    function showGenericConfirm(formId, fieldId, customOptions) {
        let modalInstance = $uibModal.open({
            templateUrl: '/ui/modal/modal.tpl.html',
            controller: 'modalController',
            backdrop: 'static',
            windowClass: 'genericModal',
            resolve: {
                options: function () {
                    return {
                        cancelButtonLabel: customOptions.noButtonLabel,
                        confirmActionButtonLabel: customOptions.yesButtonLabel,
                        summary: customOptions.confirmationMessage,
                        title: customOptions.confirmationTitle
                    };
                }
            }
        });
        return modalInstance.result;
    }

    function showChangeAgencyModal(customOptions) {
        let modalInstance = $uibModal.open({
            templateUrl: '/wizard/changeAgency/changeAgencyModal.tpl.html',
            controller: 'changeAgencyModalController',
            backdrop: 'static',
            windowClass: 'changeAgencyModalContainer',
            resolve: {
                options: function () {
                    return {
                        cancelButtonLabel: customOptions.noButtonLabel,
                        confirmActionButtonLabel: customOptions.yesButtonLabel,
                        processingIndicatorText: customOptions.processingIndicatorText,
                        title: customOptions.confirmationTitle
                    };
                }
            }
        });
        return modalInstance.result;
    }

    this.getLabelText = function () {
        let valueLabel = this.fieldStructure.fieldModel ? this.fieldStructure.fieldModel.valueLabel : null;
        if (!_.isNil(valueLabel)) {
            return valueLabel;
        }
        return this.fieldStructure.uiField.displayLabel;
    };

};

angular.module('umFormViewer')
    .controller('functionButtonController', FunctionButtonController);
